<script>
import ProNav from '$common/ProNav'
import ProInput from '$common/ProInput'
export default {
  name: 'AdminMain',
  components: {
    'pro-nav': ProNav,
    'pro-input': ProInput,
  },
  data () {
    return {
      passwords: {
        password: '',
        password_repeat: '',
      },
      passwordOptions: {
        password: {
          title: 'Password',
          type: 'password',
          errorIf: val => val && (val.length > 6) ? '' : 'Password must be longer than 6 characters',
        },
        password_repeat: {
          title: 'Password again',
          type: 'password',
          errorIf: val => val === this.passwords.password ? '' : 'Passwords must match',
        },
      },
      isLoading: false,
      invalidCode: true,
      resetSuccess: false,
      resetCode: '',
    }
  },
  computed: {
    errors () {
      const errors = Object.keys(this.passwordOptions).map(key => this.passwordOptions[key].errorIf(this.passwords[key]))
      return errors.filter(Boolean)
    }
  },
  methods: {
    onSubmit () {
      this.errors.forEach(error => this.$toast({copy: error, class: 'alert'}))
      if (this.errors.length || this.isLoading) return

      this.isLoading = true

      this.$auth.confirmPasswordReset(this.resetCode, this.passwords.password)
    .then(() => {
      this.resetSuccess = true
      this.isLoading = false
    })
    .catch((e) => {
      this.isLoading = false
      console.error(e)
      alert("There was an issue resetting your password. Please try again.")
    })
    },
  },
  mounted () {
    this.resetCode = new URLSearchParams(window.location.search).get('oobCode')
    console.log('code',this.resetCode)
    this.$auth.verifyPasswordResetCode(this.resetCode).then((email) => {
      console.log('valid code!')
      this.invalidCode = false
    }).catch(() => {
      console.log('invalid code!')
    })
  },
}
</script>


<template lang="pug">
  .account-main-main
    .account-main-container
      pro-nav
      .account.content
        .card
          .copy(
            v-if='invalidCode'
          ) It looks like your reset password code is invalid or has expired.
          .copy(
            v-else-if='resetSuccess'
          ) Password successfully changed. You may log in with your new password.
          template(
            v-else
          )
            .title Enter New Password
            .pro-form
              .form-row(
                v-for='(options, key) in passwordOptions'
              )
                pro-input(
                  :options='options'
                  v-model='passwords[key]'
                )
            .button.pro-button.major(
              @click='onSubmit'
            ) {{isLoading ? '' : 'Submit'}}
              i.material-icons.spin-me(v-if='isLoading') refresh
</template>

<style lang="sass">
  @import '$vars'
  .content
    .card
      max-width: 400px
      margin: 2rem auto 0 auto
      padding: 2rem
      box-shadow: 0 0 15px 1px grey
      border-radius: 0.5rem
      .button
        margin: auto

</style>
